module.exports = __webpack_public_path__ + "img/01_ray_mary_throwback.cc7e7bc8.jpg";